import React from "react"
import styled from "styled-components"

import { colors } from "buoy-theme"
import Checkbox from "../../common/components/CheckBox"
import Text from "../../common/components/Text"

const OptionContainer = styled.div`
  display: flex;
  align-items: center;
  border-bottom: solid 1px ${colors.neutralLighter};
  padding: 14px 0;
  display: flex;
  flex-direction: row;
  ${props =>
    props.first && `border-top: solid 1px ${props.theme.colors.neutralLighter};`};
`

const OptionText = Text.extend`
  color: ${props => props.color || colors.primary};
  padding-left: 12px;
`
const OptionTextContainer = styled.div`
  display: flex;
  align-items: center;
`

const Option = ({ option, onClick, selected, first }) => (
  <OptionContainer first={first}>
    <Checkbox
      width="20px"
      height="20px"
      selected={selected}
      onClick={() => onClick(option)} />
    <OptionTextContainer>
      <OptionText>{option.text}</OptionText>
    </OptionTextContainer>
  </OptionContainer>
)

export { Option as default }



// WEBPACK FOOTER //
// ./assets/modals/components/Option.js